<template>
  <v-container class="pa-0">
    <h1
      :style="isMobile ? '' : 'text-shadow: 3px 1px 20px rgba(0, 0, 0, 0.5)'"
      class="hero-title mb-4 px-4 px-sm-12"
      :class="{
        'text-center white--text': isMobile,
        'text-left': !isMobile,
      }"
    >
      <span v-html="title"></span>
    </h1>
    <div
      :class="{
        'mb-8': isMobile,
      }"
    >
      <div
        :style="isMobile ? '' : 'text-shadow: 3px 1px 20px rgba(0, 0, 0, 0.5)'"
        class="hero-subtitle px-4 px-sm-12"
        style="line-height: 1.5"
        :class="{
          'text-center white--text': isMobile,
          'text-left': !isMobile,
          'mx-auto': isMobile,
        }"
        v-text="subtitle"
      />
    </div>
  </v-container>
</template>

<script>
import { HOME_TITLE } from "@/consts/CMS";

export default {
  name: "hello-world",
  props: {
    title: {
      type: String,
    },
    subtitle: {
      type: String,
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      HOME_TITLE,
      amount: 1,
    };
  },
};
</script>

<style scoped>
.hero-title {
  font-family: "Fraunces", serif !important;
  font-size: 2.5rem !important;
  font-weight: bold;
}

@media (min-width: 960px) {
  .hero-title {
    font-size: 3.5rem !important;
    max-width: 800px;
  }
}

.hero-subtitle {
  font-family: "Fraunces", serif !important;
  opacity: 0.95;
  font-size: 1rem !important;
  max-width: 600px;
  display: block;
}

@media (min-width: 960px) {
  .hero-subtitle {
    font-size: 1.25rem !important;
  }
}
</style>
